import { route, tag, type PageTour } from '../pageTour';

export const siteLiveWallTour: PageTour = {
  id: 'page-site-live-wall',
  version: 1,
  title: 'Live Wall',
  summary: 'Watch several of this site\'s cameras live at once.',
  match: route('/live-wall'),
  steps: [
    {
      target: tag('wall-mode-toggle'),
      title: 'Live or Recorded',
      description: 'Switch the wall between live video and recorded footage played back side by side.',
      side: 'bottom',
    },
    {
      target: tag('live-wall-layouts'),
      title: 'Layouts',
      description: "Pick one of this site's saved layouts to put on the wall, or edit and set a default.",
      side: 'bottom',
    },
    {
      target: tag('live-wall-new-layout'),
      title: 'New layout',
      description: 'Build a new wall: choose a grid, then click a window to add a camera to it.',
      side: 'bottom',
      permission: 'live-wall.edit',
    },
    {
      target: tag('live-wall-latency'),
      title: 'Network latency',
      description: 'Show how quickly this site is responding, on top of each camera. Handy when video looks slow.',
      side: 'bottom',
    },
    {
      target: tag('live-wall-fullscreen'),
      title: 'Fullscreen',
      description: 'Fill the whole screen with the wall, for a control room display.',
      side: 'bottom',
    },
    {
      target: tag('live-wall-grid'),
      title: 'The wall',
      description: 'Live video from every camera in the layout. Double-click a camera to enlarge it, and hover for quick actions like playback.',
      side: 'top',
    },
  ],
};
